import { useSelector } from 'react-redux';
import { CatalogPreview } from 'modules/domains';
import {
  selectCatalogPreviewsLoading,
  selectCatalogPreviews,
} from 'modules/catalog/catalogPreview';
import { useCatalogPreviewFieldMappings } from 'modules/catalog/hooks/useCatalogPreviewFieldMappings';
import { useCatalogName } from './useCatalogName';
import { useCatalogPreviewContext } from '../contexts/CatalogPreviewContext';
import { useCatInSegQueryBuilderV2FeatureFlag } from '../hooks/useCatInSegQueryBuilderV2FeatureFlag';
import { useTranslation } from '../../../hooks';

const catalogPreviewLimit = 20;

const truncateCatalogPreviews = (catalogPreviews: CatalogPreview[] = []) =>
  catalogPreviews.slice(0, catalogPreviewLimit) as [];

/** holds catalog state between feature flagged QB and legacy QB */

export const useCatalogPreviewTableState = () => {
  const { t } = useTranslation();
  const isFeatureFlagged = useCatInSegQueryBuilderV2FeatureFlag();
  const catalogName = useCatalogName();

  const { data: catalogPreviewFieldTypes, isLoading: isCatalogFieldsLoading } =
    useCatalogPreviewFieldMappings(catalogName);

  const {
    catalogPreviewResults,
    isLoading,
    isOpen: isCatalogPreviewTableOpen,
  } = useCatalogPreviewContext();

  const isCatalogPreviewLoadingFromRedux = useSelector(selectCatalogPreviewsLoading);
  const catalogPreviewsFromRedux = useSelector(selectCatalogPreviews);

  const isCatalogPreviewLoading = isFeatureFlagged ? isLoading : isCatalogPreviewLoadingFromRedux;
  const isCatalogPreviewTableLoading = isCatalogPreviewLoading || isCatalogFieldsLoading;

  const catalogPreviewRows = truncateCatalogPreviews(
    isFeatureFlagged ? catalogPreviewResults : catalogPreviewsFromRedux,
  );

  const previewLimitMessage = t('catalogQuery.previewLimitMessage', { count: 20 });

  return {
    isCatalogPreviewTableOpen,
    catalogPreviewRows,
    isCatalogPreviewTableLoading,
    previewLimitMessage,
    catalogPreviewFieldTypes,
  };
};
